export const MATERIAUX = [
  { label: 'EQUIPEMENT', value: 'equipement' },
  { label: 'AUTOMATISME', value: 'automatisme' },
  { label: 'CHAUFFAGE', value: 'chauffage' },
  { label: 'ENERGIE', value: 'energie' },
  { label: 'MEUBLE', value: 'meuble' },
  { label: 'PROTECTION', value: 'protection' },
  { label: 'MENUISERIE', value: 'menuiserie' },
  { label: 'DECORATION', value: 'decoration' }
] ;
